import * as React from 'react'
import FacebookLogin, { LoginResponse } from '@greatsumini/react-facebook-login';
import { FBConfig } from '../../config';
import { Auth } from 'aws-amplify';
import { FederatedUser } from '@aws-amplify/auth/lib-esm/types';
import { ReactComponent as FacebookLogo } from '../../assets/icon/facebook.svg';


export const FundbricksFacebookLogin: React.FC<{ onFail(): void, onStart(): void }> = ({ onFail, onStart }) => {
    const [loginResponse, setLoginResponse] = React.useState<LoginResponse['authResponse']>()
    const [profileResponse, setProfileResponse] = React.useState<unknown>();

    const completeLogin = async () => {
        if (!loginResponse || !profileResponse) return
        //@ts-ignore
        const user: FederatedUser = profileResponse
        await Auth.federatedSignIn(
            "facebook",
            {
                token: loginResponse.accessToken,
                expires_at: Number(loginResponse.expiresIn) * 1000 + new Date().getTime() 
            },
            user
        );
        const d = Number(loginResponse.expiresIn) * 1000 + new Date().getTime()
        window.location.reload()
    }

    React.useEffect(() => { completeLogin() }, [loginResponse, profileResponse])

    return (
        <>
            <div style={{ marginTop: 20 }}>
            </div>

            <FacebookLogin
                style={{ backgroundColor: '#4967b5' }}
                appId={FBConfig}
                onSuccess={(res) => { setLoginResponse(res); onStart() }}
                onFail={onFail}
                onProfileSuccess={(response) => {
                    setProfileResponse(response)
                }}
            >
                <div>
                    <FacebookLogo style={{ height: 16, marginBottom: -5 }} />
                    Log ind med facebook
                </div>
            </FacebookLogin>
        </>
    )
}
